<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @open="open"
             @closed="closed"
             width="600px">
    <div v-loading="!ready" style="height: 300px; width: 360px; margin: 20px 80px">
      <el-form v-if="ready" label-position="right" label-width="100px" :model="team" :rules="rules" ref="team">
        <input-form-item label="工组名称" prop="name"></input-form-item>

        <remote-form-item label="工作范围" prop="procedureIdList" class-name="DispatchableProcedure"></remote-form-item>

        <input-number-form-item label="可施工数量" prop="maxWorkNum"></input-number-form-item>

        <status-form-item label="状态"></status-form-item>

        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()" :disabled="!ready">新 增</el-button>
      <el-button v-else type="primary" @click="save()" :disabled="!ready">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { Team } from '@/store/objdef/objectDef'
  import InputFormItem from '@/components/form/InputFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import InputNumberFormItem from '@/components/form/InputNumberFormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'

  export default {
    name: 'EditTeamDialog',
    components: {
      TextareaFormItem,
      StatusFormItem,
      InputNumberFormItem,
      RemoteFormItem,
      InputFormItem
    },
    props: {
      teamId: Number,
      readOnly: Boolean
    },
    data () {
      return {
        team: new Team(),
        loaded: false,
        rules: {
          name: [
            {
              required: true,
              message: '请输入名称',
              trigger: 'blur'
            }
          ],
          procedureIdList: [
            {
              required: true,
              message: '请选择工作范围',
              trigger: 'blur'
            }
          ],
          workHourMin: [
            {
              required: true,
              message: '请输入标准工时',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      open () {
        if (!this.isNew) {
          this.$store.dispatch('team/teamById', this.teamId).then(team => {
            this.team = team
            this.loaded = true
          })
        }
      },
      closed () {
        this.team = new Team()
        this.loaded = false
        this.$refs.team.resetFields()
      },
      add () {
        this.$refs.team.validate(valid => {
          if (!valid) return

          this.$store.dispatch('team/add', this.team).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.team.validate(valid => {
          if (!valid) return

          this.$store.dispatch('team/updateOne', this.team).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.teamId
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增工组'
        return this.readOnly ? '编辑工组' : '查看工组'
      },
      ready () {
        return this.isNew || this.loaded
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
